import { Grid, useTheme } from '@chakra-ui/react';
import React from 'react';

type KeyMetricsGridProps = {
  children: React.ReactNode;
  columns?: number;
};

export const KeyMetricsGrid: React.FC<KeyMetricsGridProps> = ({
  children,
  columns = 4,
}) => {
  const { breakpoints } = useTheme();

  return (
    <Grid
      gap={0}
      w="100%"
      mb={6}
      borderWidth="1px"
      borderColor="surface.border"
      borderRadius="lg"
      bg="surface.panel"
      overflow="hidden"
      sx={{
        gridTemplateColumns: '1fr',
        '& > *': {
          borderColor: 'metric.divider',
          borderRightWidth: 0,
          borderBottomWidth: '1px',
        },
        '& > *:last-child': {
          borderBottomWidth: 0,
        },
        [`@media screen and (min-width: ${breakpoints.md})`]: {
          gridTemplateColumns: 'repeat(2, 1fr)',
          '& > *': {
            borderRightWidth: 0,
            borderBottomWidth: '1px',
          },
          '& > *:nth-of-type(odd)': {
            borderRightWidth: '1px',
          },
          // First item of the last row and everything after it
          '& > *:nth-of-type(2n + 1):nth-last-of-type(-n + 2), & > *:nth-of-type(2n + 1):nth-last-of-type(-n + 2) ~ *':
            {
              borderBottomWidth: 0,
            },
        },
        [`@media screen and (min-width: ${breakpoints.lg})`]: {
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          '& > *': {
            borderRightWidth: 0,
            borderBottomWidth: '1px',
          },
          [`& > *:not(:nth-of-type(${columns}n))`]: {
            borderRightWidth: '1px',
          },
          [`& > *:nth-of-type(${columns}n + 1):nth-last-of-type(-n + ${columns}), & > *:nth-of-type(${columns}n + 1):nth-last-of-type(-n + ${columns}) ~ *`]:
            {
              borderBottomWidth: 0,
            },
        },
      }}>
      {children}
    </Grid>
  );
};
